mainApp.directive('docDataTableRow', ['DiscoveryQueryService', function(DiscoveryQueryService) {
    return {
        templateUrl: '/public/components/discovery/doc-data-table-row.directive.html',
        restrict: 'A',
        link: function(ctrl, el, attrs) {

            ctrl.doc = ctrl.$eval(attrs.doc);
            ctrl.fieldsSpec = ctrl.$eval(attrs.fieldsSpec);
            ctrl.selectedFields = ctrl.$eval(attrs.selectedFields);
            ctrl.expanded = ctrl.$eval(attrs.expanded);

            ctrl.toggleDocExpansion = function() {
                ctrl.expanded = !ctrl.expanded;
                ctrl.$eval(attrs.expandListener);
            }

            ctrl.addValueFilter = function(field, value) {
                ctrl.$eval(attrs.onAddFilter, {field: field, value: value, operator: 'is'});
            }

            ctrl.addValueExclusionFilter = function(field, value) {
                ctrl.$eval(attrs.onAddFilter, {field: field, value: value, operator: 'is_not'});
            }

            ctrl.formatValue = function(field, value) {
                return ctrl.$eval(attrs.valueFormatter, {field: field, value: value});
            }
        }
    }
}]);